import { Component, Input } from '@angular/core';
import { ICompetitorMarketRateDetail } from 'src/app/Shared/interface2';

/** Story 5.1/5.2: shared List-icon detail view — presentational only, each parent hosts it inside its own modal. */
@Component({
    selector: 'app-competitor-rate-detail-list',
    templateUrl: './competitor-rate-detail-list.component.html',
    styleUrls: ['./competitor-rate-detail-list.component.scss'],
    standalone: false
})
export class CompetitorRateDetailListComponent {
  @Input() competitorRates: ICompetitorMarketRateDetail[] = [];
}
